import { Dayjs } from 'dayjs'
import dayjs from 'shared/dayjs'

export const isPastDate = (date: Dayjs) => {
  const startOfToday = dayjs().startOf('day')
  return date.isBefore(startOfToday)
}

export const validateWithFormat = (dateString: string, isCheckPast = false) => {
  const dateFormat = getDateFormatBasedOnLocale()
  const dayjsObj = dayjs(dateString, dateFormat)
  const isValid = dayjsObj.format(dateFormat) === dateString

  if (isCheckPast) {
    return isCheckPast ? isValid && !isPastDate(dayjsObj) : isValid
  }

  return isValid
}

export const getDateFormatBasedOnLocale = () => {
  return dayjs.Ls[`${dayjs.locale()}`].formats.L
}

export const checkDayJsAndFormat = (date?: Dayjs | null | string) => {
  if (!date) return null

  return dayjs.isDayjs(date) ? date.format() : date
}
